import { Component, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@app/services/auth.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Observable, Subscription } from 'rxjs';

@AutoUnsubscribe()
@Component({
  selector: 'tablet-login-dialog',
  templateUrl: './tablet-login-dialog.component.html',
  styleUrls: ['./tablet-login-dialog.component.scss']
})
export class TabletLoginDialogComponent  implements OnDestroy {

  editorForm: FormGroup;
  login$ : Subscription
 

  constructor(
    public dialogRef: MatDialogRef<TabletLoginDialogComponent>,  @Inject(MAT_DIALOG_DATA) public data: any,
    private authService : AuthService,
    private fb: FormBuilder
  ) {
    this.editorForm = fb.group({
      Password: new FormControl('',[Validators.required,Validators.maxLength(6),Validators.minLength(6)])
    })

  }
  ngOnDestroy(): void {
    this.login$?.unsubscribe();
  }

  cancel() {
      this.dialogRef.close(undefined)
  }

  submit() {
    const self = this
    // napi jelszó ellenőrzés
      this.login$ = this.authService.CheckHosPassword(this.editorForm.controls["Password"].value).subscribe({
        next(value) {
            if(value == "Ok") {
                 
                self.dialogRef.close("Ok")
            }
        },
        error(err) {
            self.dialogRef.close(undefined)
        },
      })
  }
}
